import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
});


router.beforeEach(async (to, from, next) => {
  if (to.path === '/login') return next();

  // 首页重定向
  // if (to.path === '/') return redirect(next);

  next();
});


// redirect
// function redirect(next) {
//   const layoutPages = routes[0].children || [];
//   let page = layoutPages[0] ? layoutPages[0].children[0] : {};
//   let path = page.path;
//
//   next(path || '/login');
// }

export default router;
